import React from "react";
import UserList from "../../Components/UserList";

const Sponsors = () => {
  return <UserList role="sponsor" roleLabel="Sponsors" />;
};

export default Sponsors;
